import { getApi } from "./api_instance";

export const holdingReports = async ({ fromDate, toDate,page, pageSize, dispatch }) => {
  try {
    const { data } = await getApi({
      apiUrl: `/projects/api/holdings/report?toDate=${toDate}&fromDate=${fromDate}&page=${page}&limit=${pageSize}`,
      sendToken: true,
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
